import { DetailsHTMLAttributes, HTMLAttributes, HtmlHTMLAttributes } from 'react';
import styles from './Accordion.module.scss';

export const Accordion: React.FC<DetailsHTMLAttributes<HTMLDetailsElement>> = ({
  className,
  children,
  ...otherProps
}) => {
  return (
    <details className={styles['root'] + (className ? ` ${className}` : '')} {...otherProps}>
      {children}
    </details>
  );
};

export const AccordionSummary: React.FC<HTMLAttributes<HTMLElement>> = ({
  className,
  children,
}) => {
  return (
    <summary className={styles['summary'] + (className ? ` ${className}` : '')}>{children}</summary>
  );
};

export const AccordionContent: React.FC<HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return <div {...props} />;
};
